import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { MatButtonModule, MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS, MatSnackBarModule } from '@angular/material';
import { A11yModule } from '@angular/cdk/a11y';

import { ErrorDialogComponent } from '../dialog/errordialog/error.dialog.component';
import { SaveDialogComponent } from '../dialog/savedialog/save.dialog.component';

const imports = [
  CommonModule,
  BrowserModule,
  MatDialogModule,
  MatButtonModule,
  A11yModule,
];

const exps = [
  ErrorDialogComponent,
  SaveDialogComponent
];

const declarations = [
  ErrorDialogComponent,
  SaveDialogComponent
];

const providers = [
  {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {hasBackdrop: false}},
];

@NgModule({
  imports: [...imports],
  exports: [...exps],
  declarations: [...declarations],
  providers: [...providers],
  entryComponents: [
    ErrorDialogComponent,
    SaveDialogComponent,
  ]
})
export class DialogModule { }
